<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <div class="avatar">
                            <v-avatar class="page-icon teal mr-2 elevation-5">
                                <v-icon large class="white--text">
                                    {{ mdiPlusBox }}
                                </v-icon>
                            </v-avatar>
                        </div>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Out-Patient Consultation
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>

        <!-- Cards -->

        <div class="affiliatedWrapper">
            <v-card
                class="card"
                raised
                @click="
                    $router.push(
                        `/dashboard/consultation/main/`
                    )
                "
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column text-center">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiFileDocument }}
                            </v-icon>
                        </v-avatar>
                        <span style="word-break: normal;">Consultation Request</span>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="
                    $router.push(`/dashboard/consultation/history/`)
                "
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5">
                            <v-icon size="50" class="white--text">
                                {{ mdiTable }}
                            </v-icon>
                        </v-avatar>
                        History
                    </v-card-title>
                </v-card-text>
            </v-card>
        </div>
    </section>
</template>

  <script>
import { mdiInformationVariant, mdiPlusBox, mdiTable, mdiFileDocument } from '@mdi/js'

export default {
    data: () => ({
        mdiInformationVariant,
        mdiTable,
        mdiPlusBox,
        mdiFileDocument
    })
}
  </script>

  <style scoped>
  section {
    background-image: url("../../assets/dashboardBG.webp");
    background-position: center;
    background-size: cover;
  }
  .affiliatedWrapper {
    height: 90%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
  }
  .card {
    width: 300px;
    height: 200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: linear-gradient(180deg, #b4ff9a 0%, #02cf9f 100%);
  }
  .ape-btn {
    word-break: normal;
    text-align: center;
  }

  @media (max-width: 390px) {
    .page-icon {
      display: none;
    }
  }

  @media (max-width: 599px) {
    /* Navbar */
    .nav {
      margin-top: 60px;
    }
    .nav h2 {
      font-size: 25px;
    }
    .avatar {
      margin: 10px auto;
    }
    .card {
      height: 200px;
      width: 250px;
      margin: 10px auto;
    }
  }

  @media (min-width: 599px) and (max-width: 1264px) {
    /* Navbar */
    .nav {
      margin-top: 60px;
    }
    .nav h2 {
      font-size: 25px;
    }
  }
  </style>
